import { EventEmitter } from "@angular/core";
import { SettingsModel } from "../../shared/models/settings.model";
import { ColumnModel } from "../../shared/models/column.model";

export class SettingsBuildData{
    module = {
        name: "Settings",
        new_name: "settings",
        has_dot_menu: true,
        icon:'fa-gear',
        permission:'settings'
    }
    
    onReload: EventEmitter < boolean > = new EventEmitter<boolean>();//Forces Reload of codeblack table on emit.
    rowFunction = (row:SettingsModel) => {//Generates Row for codeblack-table
        return SettingsModel.getListRow(row);
    }
    
    columns:ColumnModel[] = [
        {
            title: "Id",
            prop: "id",
            flex_grow: 1,
            row_accessor: "id",
            class:""//force-flex force-flex-end
        },
        {
            title: "Key",
            prop: "key",
            flex_grow: 4,
            row_accessor: "key",
        }
    ];

    constructor(){
        for(let col of this.columns){
            col = new ColumnModel(col);
        }
    }

}